import { render } from "./AddRuleSetPage.vue?vue&type=template&id=a46cdd1c&ts=true"
import script from "./AddRuleSetPage.vue?vue&type=script&lang=ts"
export * from "./AddRuleSetPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__